import React from "react";
import './i18n';

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify';


import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
  {/* <React.StrictMode> */}
    <App />
    <ToastContainer style={{width:"auto"}} autoClose={10000}/>
  {/* </React.StrictMode> */}
  </BrowserRouter>
);

reportWebVitals();
